import Vue from 'vue';
import store from '../common/js/vuex/store';
import personalLoanCalculator from './personal-loan-calculator/personal-loan-calculator.vue';
import personalLoanCalculatorStore from '../applications/personal-loan-calculator/personal-loan-calculator-vuex';
if (!store.hasModule(['personalLoanCalculator'])) {
	store.registerModule('personalLoanCalculator', personalLoanCalculatorStore);
}

Vue.component('personal-loan-calculator', personalLoanCalculator);
